// extracted by mini-css-extract-plugin
module.exports = {"row":"CatalogGrid_row__3fCs7","col":"CatalogGrid_col__NNJ8_"};